export default "__VITE_ASSET__960ed09a__"